import List from './list'
import ModalAdd from './add/modalAdd'
import PageAdd from './add/pageAdd'
import EmbedAdd from './add/embedAdd'
import { MODE } from '../../constant'
import routerKit from '../../utils/routerKit'

const cache = {}

export function generateComponent(type, configs, nestedList = []) {
  const cacheKey = `${configs.name}-${type}`
  return cache[cacheKey] || (cache[cacheKey] = {
    name: 'MainListView',
    render (h) {
      let resChild = null
      let Add = null
      switch (configs.mode) {
        case MODE.EDIT_IN_DIALOG:
          Add = ModalAdd
          break
        case MODE.EDIT_IN_NEW_PAGE:
          Add = PageAdd
          break
        case MODE.EDIT_IN_TABLE:
          Add = EmbedAdd
          break
      }
      switch (type) {
        case 'list':
          resChild = (
            <List
              class="list-wrapper"
              resourceType="main"
              mode={configs.mode}
              data={configs.data}
              schema={configs.schema}
              actions={configs.actions}
              hooks={configs.hooks}
              options={configs.options}
              on-triggerSearch={async params => {
                const loadingInstance = this.$loading({ target: '.list-wrapper' })
                await configs.data.fetch.list(this.$store, params)
                loadingInstance.close()
              }}
              on-triggerFetchOne={id => configs.data.fetch.one(this.$store, id)}
              on-triggerUpdate={async params => {
                // TODO: after moving 'fetch' action to store, cb is useless
                await configs.data.update(this.$store, params.data)
                params.cb && params.cb()
              }}
              on-triggerDelete={async params => {
                // TODO: after moving 'fetch' action to store, cb is useless
                await configs.data.delete(this.$store, params.data)
                params.cb && params.cb()
              }}
              on-addHandle={this.addHandler}
              on-editHandle={this.editHandler}
              on-detailHandle={this.detailHandler}
            />
          )
          break;
        case 'add':
          resChild = (
            <Add
              schema={configs.schema}
              data={configs.data}
              nestedList={nestedList}
              on-triggerFetchOne={id => configs.data.fetch.one(this.$store, id)}
            />
          )
          break
        case 'edit':
          resChild = (
            <Add
              schema={configs.schema}
              data={configs.data}
              model={configs.data.provider.one(this.$store.state)}
              nestedList={nestedList}
              on-triggerFetchOne={id => configs.data.fetch.one(this.$store, id)}
            />
          )
          break
        case 'detail':
          resChild = (
            <Add
              schema={configs.schema}
              data={configs.data}
              model={configs.data.provider.one(this.$store.state)}
              isDetail={true}
              nestedList={nestedList}
              on-triggerFetchOne={id => configs.data.fetch.one(this.$store, id)}
            />
          )
          break
      }
      return h('div', [resChild])
    },
    methods: {
      addHandler() {
        this.$router.push(this.$route.path + '/add')
      },
      editHandler(query) {
        this.$router.push({
          path: this.$route.path + '/edit',
          query
        })
      },
      detailHandler(query) {
        this.$router.push({
          path: this.$route.path + '/detail',
          query
        })
      }
    }
  })
}

export default function ListViewFactory(configs = {}, nestedList = []) {
  return {
    [`list`]: generateComponent('list', configs),
    [`add`]: generateComponent('add', configs, nestedList),
    [`edit`]: generateComponent('edit', configs, nestedList),
    [`detail`]: generateComponent('detail', configs, nestedList)
  }
}



// WEBPACK FOOTER //
// ./packages/creator/ListView/index.js